import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter } from 'eurogard-open-api-remote-method';
import { ProxyRemoteMethod } from 'eurogard-remote-method';
import { Inject, Injectable, Optional } from '@angular/core';
import { RXAP_FORM_CONTEXT, RXAP_FORM_INITIAL_STATE } from 'eurogard-forms';

export interface SubmitEditForm extends Record<string, unknown> {
  uuid: string;
}

@Injectable()
export class SubmitEditFormAdapter extends ProxyRemoteMethod<unknown, SubmitEditForm, OpenApiRemoteMethodParameter<{ uuid: string }>> {

  constructor(
    @Inject(OpenApiRemoteMethod)
      remoteMethod: OpenApiRemoteMethod<unknown, OpenApiRemoteMethodParameter<{ uuid: string }>, SubmitEditForm>,
    @Optional()
    @Inject(RXAP_FORM_CONTEXT)
    private readonly context: { uuid: string } | null,
    @Optional()
    @Inject(RXAP_FORM_INITIAL_STATE)
    private readonly initial: { uuid: string } | null,
  ) {
    super(remoteMethod);
  }

  public transformParameters(value: SubmitEditForm): OpenApiRemoteMethodParameter {
    const uuid = this.context?.uuid ?? this.initial?.uuid ?? value.uuid;
    if (!uuid) {
      throw new Error('The provided context and form value do not have a uuid property');
    }
    return {
      parameters: {uuid},
      requestBody: value,
    };
  }

}

export function SubmitEditFormAdapterFactory(
  remoteMethod: OpenApiRemoteMethod,
  context: { uuid: string },
  initial: { uuid: string },
) {
  return new SubmitEditFormAdapter(
    remoteMethod,
    context,
    initial,
  );
}
